import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'badgeClient',
  standalone: true,
})
export class BadgeClientPipe implements PipeTransform {
  private readonly statusColorMap: { [key: string]: string } = {
    organization: 'text-organization',
    'self-employed': 'text-self-employed',
    individual: 'text-individual',
    guarantee: 'text-guarantee',
    campaign: 'text-campaign',
  };

  transform(status: string): string {
    return status ? this.statusColorMap[status] || 'text-individual' : 'text-individual';
  }
}
